import { takeLatest, call, put } from 'redux-saga/effects';

import {
  GET_TREATMENT_PAGE_START,
  GET_TREATMENT_PAGE_ERROR,
  GET_TREATMENT_PAGE_SUCCESS,
  TOGGLE_CHECKBOX_START,
  TOGGLE_CHECKBOX_SUCCESS,
  TOGGLE_CHECKBOX_ERROR,
  DOWNLOAD_TREATMENT_PRESCRIPTION_START,
  DOWNLOAD_TREATMENT_PRESCRIPTION_SUCCESS,
  DOWNLOAD_TREATMENT_PRESCRIPTION_ERROR,
  DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_START,
  DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_SUCCESS,
  DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_ERROR,
} from '../actions/treatmentPage';
import api from '../api';

function createGetTreatmentPage() {
  return function* (option) {
    const { treatmentId, language } = option.payload;

    try {
      const data = yield call(() =>
        api.getTreatmentPage(treatmentId, language),
      );
      const action = { type: GET_TREATMENT_PAGE_SUCCESS, data };

      yield put(action);
    } catch (error) {
      const action = { type: GET_TREATMENT_PAGE_ERROR, error };

      yield put(action);
    }
  };
}

function* getTreatmentPageWatcher() {
  yield takeLatest(GET_TREATMENT_PAGE_START, createGetTreatmentPage());
}

function createToggleCheckbox() {
  return function* (option) {
    const { stepId, dayNumber, treatmentId, language } = option.payload;

    try {
      const data = yield call(() =>
        api.toggleCheckbox(stepId, dayNumber, treatmentId, language),
      );
      const action = { type: TOGGLE_CHECKBOX_SUCCESS, data };

      yield put(action);
    } catch (error) {
      const action = { type: TOGGLE_CHECKBOX_ERROR, error };

      yield put(action);
    }
  };
}

function* toggleCheckboxWatcher() {
  yield takeLatest(TOGGLE_CHECKBOX_START, createToggleCheckbox());
}

function createDownloadTreatmentPrescription() {
  return function* (option) {
    const { documentId, treatmentId, stepId } = option.payload;

    try {
      const data = yield call(() =>
        api.downloadTreatmentPrescription(documentId, treatmentId),
      );
      const action = {
        type: DOWNLOAD_TREATMENT_PRESCRIPTION_SUCCESS,
        data: data,
        stepId: stepId,
      };

      yield put(action);
    } catch (error) {
      const action = { type: DOWNLOAD_TREATMENT_PRESCRIPTION_ERROR, error };

      yield put(action);
    }
  };
}

function* downloadTreatmentPrescriptionWatcher() {
  yield takeLatest(
    DOWNLOAD_TREATMENT_PRESCRIPTION_START,
    createDownloadTreatmentPrescription(),
  );
}

function createDownloadNutritionAdviceActionPlan() {
  return function* (option) {
    const { treatmentId, stepId, buttonType } = option.payload;

    try {
      const data = yield call(() =>
        api.downloadNutritionAdviceActionPlan(
          buttonType,
          treatmentId,
          stepId,
        ),
      );
      const action = {
        type: DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_SUCCESS,
        data: data,
        stepId: stepId,
        buttonType: buttonType,
      };

      yield put(action);
    } catch (error) {
      const action = {
        type: DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_ERROR,
        error,
        stepId: stepId,
        buttonType: buttonType,
      };

      yield put(action);
    }
  };
}

function* downloadNutritionAdviceActionPlanWatcher() {
  yield takeLatest(
    DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_START,
    createDownloadNutritionAdviceActionPlan(),
  );
}

const treatmentPageSagas = [
  getTreatmentPageWatcher(),
  toggleCheckboxWatcher(),
  downloadTreatmentPrescriptionWatcher(),
  downloadNutritionAdviceActionPlanWatcher(),
];

export default treatmentPageSagas;
